import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { dashboardHierarchyVisibilitiesMergedDataItemsSelector } from "@/store/dashboards/selectors/dashboard-hierarchy-visibility/dashboardHierarchyVisibilitiesMergedDataItemsSelector";
import { Dashboard } from "@/services/cloudchipr.api";

export const homeDashboardSelector = createDraftSafeSelector(
  [dashboardHierarchyVisibilitiesMergedDataItemsSelector],
  (data): Dashboard | undefined => {
    return data?.find(
      (item) => "is_home_page" in item && item.is_home_page,
    ) as Dashboard;
  },
);
